<div class="layout-topbar">
   <div class="flex gap-2">
      <button #menubutton type="button" class="topbar-menubutton p-link p-trigger mr-2" (click)="onMenuButtonClick()">
         <i class="pi pi-chevron-right"></i>
      </button>
      <p-menubar [model]="itemsStart" [autoDisplay]="false" [autoHide]="true"> </p-menubar>
   </div>

   <div class="topbar-end flex gap-3 align-items-center pr-4">
      <p-chip
         [label]="selectedTimezone"
         icon="pi pi-hourglass"
         [pTooltip]="'DATA.COMMON.HUSO.TOOLTIP' | translate"
         [tooltipPosition]="'bottom'"
         (click)="showTimezone()"
         [ngStyle]="{ cursor: 'pointer' }"
      ></p-chip>
      <p-button
         *ngIf="isAllow([PERMISSION_TYPE.FULL_ACCESS])"
         [label]="'DATA.COMMON.ASK' | translate"
         [ariaLabel]="'DATA.COMMON.ASK' | translate"
         severity="secondary"
         text="true"
         [styleClass]="(widgetOpen$ | async) ? 'text-only ask-active' : 'text-only'"
         (onClick)="toggleAskWidget()"
      >
         <ng-template pTemplate="icon" let-class="class">
            <svg
               class="{{ class }} elevenlabs-ask__icon mr-2"
               xmlns="http://www.w3.org/2000/svg"
               width="24"
               height="24"
               viewBox="0 0 24 24"
               fill="none"
               stroke="currentColor"
               stroke-width="2"
               stroke-linecap="round"
               stroke-linejoin="round"
               aria-hidden="true"
               focusable="false"
            >
               <path
                  d="M12.7 3H4a2 2 0 0 0-2 2v16.286a.71.71 0 0 0 1.212.502l2.202-2.202A2 2 0 0 1 6.828 19H20a2 2 0 0 0 2-2v-4.7"
               />
               <circle cx="19" cy="6" r="3" />
            </svg>
         </ng-template>
      </p-button>
      <p-divider layout="vertical" [style]="{ 'height': '5px' }" />
      <p-button
         *ngIf="isAllow([PERMISSION_TYPE.FULL_ACCESS])"
         [icon]="loading ? 'pi pi-spin pi-spinner' : 'pi pi-server'"
         [routerLink]="['/tenants']"
         [queryParamsHandling]="'preserve'"
         [pTooltip]="!loading ? tenantName : ''"
         [tooltipPosition]="'bottom'"
         [label]="loading ? 'Cargando...' : (tenantName | ellipsis: 8)"
         severity="secondary"
         text="true"
         styleClass="text-only"
      ></p-button>
      <button type="button" class="p-link m-2" (click)="onProfileButtonClick()">
         <p-avatar
            [label]="letters(user.name)"
            styleClass="w-2rem h-2rem border-circle"
            size="normal"
            [style]="{ 'background-color': '#c1cdd7', color: 'black' }"
            shape="circle"
         ></p-avatar>
      </button>
   </div>
</div>
